import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastService } from '@northfork/ng-basics'

@Component({
  selector: 'hs-invalid-transaction-id-popover',
  templateUrl: './invalid-transaction-id-popover.component.html',
  styleUrls: ['./invalid-transaction-id-popover.component.scss'],
})
export class InvalidTransactionIdPopoverComponent {
  constructor(
    readonly activeModal: NgbActiveModal,
    public toastService: ToastService,
  ) {}

  @Input() transactionIds: string[] | number[] = []

  copyTransactionIdsTableFormat() {
    navigator.clipboard.writeText(this.transactionIds.join('\n'))
    this.toastService.success('Copied to Clipboard')
  }

  copyTransactionIdsCommaSeparated() {
    navigator.clipboard.writeText(this.transactionIds.join(','))
    this.toastService.success('Copied to Clipboard')
  }
}
